<template>
  <div class="home">
    <section class="banner">
      <div class="overlay"></div>
      <div class="container">
        <div class="row no-gutters align-items-center justify-content-end">
          <div class="col-md-6">
            <h1 class="mb-4">WE’LL GET YOU OUT OF DEBT SLAVERY</h1>
            <p class="mb-4">Get your payments decreased by up to 70% and ease your cash-flow strain!</p>
            <b-button size="lg" variant="primary" v-b-modal.modal-center>Request a Quote</b-button>
          </div>
        </div>
      </div>
    </section>

    <section class="img bg-light mt-50 mb-50" id="about-section">
      <div class="container">
        <div class="row d-flex">
          <div class="col-md-6 col-lg-6 d-flex order-md-last">
            <div class="img-about img d-flex align-items-stretch">
              <div class="img d-flex align-self-stretch align-items-end"></div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 pr-lg-5 py-3 py-lg-5">
            <div class="row justify-content-start py-3 py-lg-5">
              <div class="col-md-12">
                <h2
                  class="mb-4"
                  style="font-size: 44px; text-transform: capitalize;"
                >Welcome to Business Debt Adjusters!</h2>
                <p>For years, we have been helping small business owners get out of financial hardship once and for all. We are here to lend a helping hand to those who are stuck in the unsecured commercial debt pit. We have unlocked a debt-free life for numerous businesses across the US, and now we are ready to unlock valuable opportunities for you.</p>
                <p>
                  We at
                  <strong>Business Debt Adjusters</strong> realize how exhausted you must be of payday loans and over-stressed due to threatening collector calls. We’ll be happy to take over the burden of dealing with creditors and reduce the sum you owe.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="img mt-50 mb-50 card_section">
      <div class="container">
        <div class="row">
          <div
            class="card_block col-md-4 col-lg-4 col-sm-6 col-xs-12 d-flex justify-content-center"
          >
            <div class="card">
              <img class="card-img-top" src="../assets/shape1.png" alt="Card image cap" />
              <div class="card-body">
                <h5 class="card-title">Get Your Payments Reduced - Ease Your Cash Crunch</h5>
                <p
                  class="card-text"
                >Turning your business into a flourishing enterprise can be very challenging...</p>
                <router-link to="/paymentsReduced" class="btn btn-primary">Read more</router-link>
              </div>
            </div>
          </div>
          <div
            class="card_block col-md-4 col-lg-4 col-sm-6 col-xs-12 d-flex justify-content-center"
          >
            <div class="card">
              <img class="card-img-top" src="../assets/shape2.png" alt="Card image cap" />
              <div class="card-body">
                <h5 class="card-title">Your Customized Debt Relief Program</h5>
                <p
                  class="card-text"
                >As we all know, Merchant Cash Advances generally have much higher fees and...</p>
                <router-link to="/personalizedDebt" class="btn btn-primary">Read more</router-link>
              </div>
            </div>
          </div>
          <div
            class="card_block col-md-4 col-lg-4 col-sm-6 col-xs-12 d-flex justify-content-center"
          >
            <div class="card">
              <img class="card-img-top" src="../assets/shape3.png" alt="Card image cap" />
              <div class="card-body">
                <h5 class="card-title">Don’t Let Your Debt Load Break You Down!</h5>
                <p
                  class="card-text"
                >If collector calls put you on edge and you’re starting to lose your peace of mind...</p>
                <router-link to="/debtLoadBreak" class="btn btn-primary">Read more</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="slider mb-50">
      <div class="container">
        <div class="row">
          <div class="col center">
            <Slider />

            <router-link to="/howItWorks">
              <b-button size="lg" variant="primary">Read More</b-button>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <RealResults />
  </div>
</template>

<script>
import Slider from "@/components/slider";
import RealResults from "@/components/realResults";
export default {
  name: "Home",
  components: {
    Slider,
    RealResults
  }
};
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  opacity: 0.3;
  background: #000000;
}
.banner {
  background-image: url("../assets/bg_1.jpg");
  background-position: center center;
  position: inherit;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: calc(100vh - 106px);
  position: relative;
  display: flex;
  align-items: center;

  h1 {
    font-size: 58px;
    color: #fff;
    line-height: 1.2;
    font-weight: 400;
  }
  p {
    font-size: 20px;
    line-height: 1.5;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.8);
  }
}
#about-section {
  .img-about {
    width: 100%;
    .img {
      width: 100%;
      background-image: url("../assets/about.jpg");
      box-shadow: -20px 20px 69px -27px rgba(0, 0, 0, 0.3);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }

    p,
    h2 {
      line-height: 1.8;
      font-family: "Nunito Sans", sans-serif;
    }
  }
}
.card_section {
  .card_block {
    margin: 10px auto;

    .card {
      border-radius: 0;
      box-shadow: 11px 11px 46px -30px rgba(0, 0, 0, 0.99);
      border: none;
    }
  }
}
.btn {
  a {
    color: #fff;
  }
}

@media(max-width:376px){
  .banner{
    h1{
      font-size: 40px;
      margin-top: 5px;
    }
  }
}
</style>
